export const SHOULD_REFRESH_REPORT_DEFAULT_SETTING_INIT_VALUE = 0;
